module.exports = __webpack_public_path__ + "static/media/AZW.92241741.svg";